
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_43_2537)"}},[_c('path',{attrs:{"d":"M10.315 51.266a3.944 3.944 0 01-1.046-.265c-1.347-.53-2.292-1.773-2.513-3.22L.744 5.36A4.154 4.154 0 012.212 1.59a3.996 3.996 0 013.94-.632l39.55 15.166a4.059 4.059 0 012.554 3.18c.221 1.447-.322 2.915-1.448 3.832L13.27 50.41a3.933 3.933 0 01-2.955.877v-.02zM9.67 11.048l4.062 28.518 22.52-18.326L9.67 11.048z","fill":"#ED6A95"}}),_c('path',{attrs:{"d":"M10.757 52c-.18 0-.342 0-.523-.02a4.331 4.331 0 01-1.226-.306 4.801 4.801 0 01-2.936-3.771L.04 5.463C-.18 3.79.463 2.099 1.77 1.06A4.683 4.683 0 016.393.306l39.55 15.165a4.78 4.78 0 012.996 3.73 4.83 4.83 0 01-1.71 4.485L13.714 50.96a4.602 4.602 0 01-2.936 1.06l-.02-.02zM4.725 1.406c-.744 0-1.488.245-2.09.734A3.366 3.366 0 001.427 5.26l6.032 42.44a3.316 3.316 0 002.07 2.65c.282.102.564.183.865.224.885.102 1.75-.163 2.453-.714l33.518-27.274a3.438 3.438 0 001.206-3.16 3.369 3.369 0 00-2.11-2.629L5.891 1.631a3.38 3.38 0 00-1.167-.225zm8.485 39.485L8.807 9.968 37.62 21.016 13.19 40.87l.02.02zm-2.674-28.763l3.72 26.112 20.63-16.776-24.35-9.336z","fill":"#552C5C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_43_2537"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h49v52H0z"}})])])])
          )
        }
      }
    